import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=289228b6"
import script from "./SortSelect.vue?vue&type=script&lang=ts"
export * from "./SortSelect.vue?vue&type=script&lang=ts"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=289228b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports